<template>
  <div style="width: 78%">
    <div class="work_calendar__calendar" v-for="(week,i) in currentDates" :key=i>
      <div
        class="work_calendar__calendar_day_box"
        :class="{'invalid_day': !day.isCurMonth}"
        v-for="(day,j) in week" :key=j>
          <span v-if="i == 0" style="margin: 6px 0 0 6px;">{{ weekdays[j] }}</span>
          <span
          class="work_calendar__calendar_day_box--day_number"
          :class="{'work_calendar__calendar_day_box--diactive':!day.isCurMonth, 'work_calendar__calendar_day_box--today':day.isToday && day.isCurMonth }">
            {{day.monthDay}}
          </span>

          <div
            v-for="task in tasks"
            v-if="checkTasks(new Date(day.date), task.attributes)"
            class="work_calendar__calendar_day_box--event_container"
            :style="'background-color: '+colors[task.attributes.task_type]"
            :title="task.attributes.title"
            @click="$emit('find-task-info', task.id)">

            <span v-if="new Date(task.attributes.task_start).toLocaleDateString() == new Date(day.date).toLocaleDateString()">
              {{ task.attributes.task_start | moment("h:mm a") }}
            </span>

            {{ task.attributes.title }}
          </div>
      </div>
    </div>

  </div>
</template>

<script>
import moment from 'moment';

export default {
  props: ['currentMonth', 'tasks'],
  data(){
    return {
      weekdays: ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'],
      colors: {
        'Mantenimiento': '#D50B00',
        'Inspecciones': '#2C9BE5',
        'Simulacro': '#3CB679',
        'Otro': '#F6BF26'
      }
    }
  },
  computed:{
    currentDates(){
      return this.getCalendar()
    }
  },
  methods: {
    getCalendar(){
      let monthViewStartDate = this.getMonthViewStartDate(this.currentMonth, this.firstDay);
      const calendar = [];

      for(let perWeek = 0 ; perWeek < 6 ; perWeek++) {
        let week = [];
        for(let perDay = 0 ; perDay < 7 ; perDay++) {
          week.push({
            monthDay : monthViewStartDate.date(),
            isToday : monthViewStartDate.isSame(moment(), 'day'),
            isCurMonth : monthViewStartDate.isSame(this.currentMonth, 'month'),
            weekDay : perDay,
            date : moment(monthViewStartDate),
          });
          monthViewStartDate.add(1, 'day');
        }
        calendar.push(week);
      }
      return calendar
    },

    getMonthViewStartDate(date, firstDay){
      firstDay = parseInt(firstDay);
      let start = moment(date);
      let startOfMonth = moment(start.startOf('month'));

      start.subtract(startOfMonth.day(), 'days');

      if (startOfMonth.day() < firstDay) {
        start.subtract(7, 'days');
      }
      start.add(firstDay, 'days');
      return start;
    },

    checkTasks(day, task){
      return (new Date(task.task_finish) > day && new Date(task.task_start) < day) ||
              (new Date(task.task_start).toLocaleDateString() == day.toLocaleDateString() ||
              new Date(task.task_finish).toLocaleDateString() == day.toLocaleDateString())
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/SGSST/work_calendar/WorkCalendar.vue